import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import {
  setIsShowFindAllViewList,
  setTableData,
} from "../../../actions/transOperationActions";
import {
  findAndReplaceSearch,
  findAndReplaceMove,
  afterFindReplaceChange,
  setFindAndReplaceSentence,
} from "../../../actions/transOperation_find_Actions";

import {
  Label,
  Form,
  FormField,
  TextBox,
  CheckBox,
  ComboBox,
  LinkButton,
} from "rc-easyui";

class FindAllView_replace extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        findString: null,
        wantReplaceString: null,
        isSubtitle: true,
        isMemo: true,
        isCaseSensitivity: false,
        isSource: false,
      },
    };

    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleReplace = this.handleReplace.bind(this);
  }
  async componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
    }
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    this.setState({ user: user }); 
  }

  async handleSubmit(moveType) {
    const { data } = this.props.editTable;
    const { user } = this.state;
    if (user.findString !== null) {
      //送入檢查,取得尋找結果
      const replaceArray = this.props.findAndReplaceSearch(
        moveType,
        data,
        user.findString,
        this.props.transOperation.tableColMapping
      );

      //找到出結果
      if (replaceArray.length !== 0) {
        //確認目前table的row位置
        const tableMoveRow = await this.props.findAndReplaceMove(
          moveType,
          replaceArray,
          this.props.transOperation.findAndReplaceSelectRowCol,
          this.props.transOperation.tableColMapping
        );

        this.props.tableMoveRow(tableMoveRow);
      }
    }
  }

  //執行更新 0:只更新當前的
  async handleReplace(type) {
    const { user } = this.state;
    const { data } = this.props.editTable;
    const { videoFps } = this.props.transOperation;
    const { findFrameSplitValue } = this.props.findOperation;

    if (user.findString !== null && user.wantReplaceString !== null) {
      let targetTitle = this.props.transOperation.findAndReplaceSentence; //
      var re = new RegExp(user.findString, "g");
      var newTitle = targetTitle.replace(re, user.wantReplaceString);

      if (type === 0) {
        //只換一次
        //位置
        let location = this.props.transOperation.findAndReplaceSelectRowCol;
        // console.log(location);

        //更新
        this.props.afterFindReplaceChange(data, [
          location[0],
          "SubtitleCaption",
          targetTitle,
          newTitle,
        ]);
      } else if (type === 1) {
        // 全換
        let newData = data; 

        let firstIndex = null;

        data.forEach(function (obj, index) {
          let checkObj = data[index];

          let rowSubtitle = checkObj.SubtitleCaption;

          var n = rowSubtitle.includes(user.findString);

          if (n === true) {
            if (firstIndex === null) {
              firstIndex = index;
            }

            var re = new RegExp(user.findString, "g");
            var newTitle = rowSubtitle.replace(re, user.wantReplaceString);

            newData[index].SubtitleCaption = newTitle;

            // console.log(newTitle);
          }
        });

        if (firstIndex !== null) {
          //更新搜尋的顯示文字
          this.props.setFindAndReplaceSentence(
            newData[firstIndex].SubtitleCaption
          );

          //更新
          await this.props.setTableData(
            newData,
            findFrameSplitValue,
            videoFps,
            firstIndex,
            firstIndex + 1
          );

          //初始字幕跟拖拉資料
          this.props.context.initSubAndDragData();
        }
      }
    }

    //初始字幕跟拖拉資料
    this.props.context.initSubAndDragData();
  }

  render() {
    const { user } = this.state;

    let mainContent;

    mainContent = (
      <div className="row col-12 small">
        <Form
          style={{ fontSize: "12px", width: 500 }}
          model={user}
          // labelWidth={110}
          labelAlign="left"
          onChange={this.handleChange.bind(this)}
        >
          <div>
            <div className="row col-12">
              <div className="col-6">
                <FormField
                  name="findString"
                  labelPosition="after"
                  labelAlign="left"
                  style={{ marginBottom: 0, float: "left", width: "100%" }}
                >
                  <TextBox />
                </FormField>
              </div>

              <div className="col-6">
                <FormField
                  name="wantReplaceString"
                  labelPosition="after"
                  labelAlign="left"
                  style={{ marginBottom: 0, float: "left", width: "100%" }}
                >
                  <TextBox />
                </FormField>
              </div>
            </div>

            <div id="findAndReplaceSentence" className="row col-12 m-3">
              {this.props.transOperation.findAndReplaceSentence}
            </div>

            <div className="row col-12">
              <table className="table">
                <tbody>
                  <tr>
                    <td>
                      <FormField style={{ width: "100%", float: "right" }}>
                        <LinkButton
                          onClick={() => {
                            // this.props.handleFindAndReplaceSearch_Next(0,user);
                            this.handleSubmit(0);
                          }}
                        >{`< Prev`}</LinkButton>
                      </FormField>
                    </td>

                    <td>
                      <FormField style={{ width: "100%", float: "right" }}>
                        <LinkButton
                          onClick={() => {
                            //this.props.handleFindAndReplaceSearch_Next(1,user);
                            this.handleSubmit(1);
                          }}
                        >{` Next >`}</LinkButton>
                      </FormField>
                    </td>
                    <td>
                      <FormField style={{ width: "100%", float: "right" }}>
                        <LinkButton
                          onClick={() => {
                            this.props.handleReplace(0, user);
                          }}
                        >
                          Replace
                        </LinkButton>
                      </FormField>
                    </td>
                    <td>
                      <FormField style={{ width: "100%", float: "right" }}>
                        <LinkButton
                          onClick={() => {
                            this.props.handleReplace(1, user);
                          }}
                        >
                          Replace All
                        </LinkButton>
                      </FormField>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Form>
      </div>
    );

    return mainContent;
  }
}

FindAllView_replace.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  findAllToSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
  editTable: state.editTable,
});

export default connect(mapStateToProps, {
  findAndReplaceSearch,
  setIsShowFindAllViewList,
  findAndReplaceMove,
  afterFindReplaceChange,
  setTableData,
  setFindAndReplaceSentence,
})(withRouter(FindAllView_replace));



// WEBPACK FOOTER //
// ./src/components/translations/objects/FindAllView_replace.js